import { render } from "./PokemonCard.vue?vue&type=template&id=264b5534&scoped=true"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"

import "./PokemonCard.vue?vue&type=style&index=0&id=264b5534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264b5534"]])

export default __exports__